






































import Vue from 'vue';
import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { confirm } from 'devextreme/ui/dialog';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxSelectBox } from 'devextreme-vue/select-box';
import { BatchDetailsDto } from '@/models/batch/BatchDetailsDto';
import { BatchEventTypeEnum } from '@/models/batch/BatchEventTypeEnum';
import { ClientDto } from '@/models/client/ClientDto';
import { ReportTypeEnum } from '@/models/ReportTypeEnum';
import { BatchService } from '@/service/BatchService';
import moment from 'moment';

@Component({
  components: {
    DxPopup,
    DxSelectBox,
    DxToolbarItem
  }
})
export default class SendReportsConfirmation extends Vue {
  private readonly batchService: BatchService = new BatchService();

  private showDialog: boolean = false;

  client: ClientDto | null = null;
  dialogResult: boolean | null = null;
  reportType: ReportTypeEnum = ReportTypeEnum.Analysis;
  selectedBatch: BatchDetailsDto | null = null;

  @Watch('client')
  async onClientChanged() {
    this.selectedBatch = null;
    await this.batchesDataSource.reload();
  }

  private get title() {
    return `Manual ${this.reportTypeName} Report Sending for ${this.clientName}`;
  }

  private get message() {
    return `<span>Are you sure you want to send the ${this.reportTypeName} reports for the selected batch for <b>${this.clientName}</b> right now?</span>`;
  }

  private get clientName() {
    return this.client != null ? this.client.ClientName : 'Unknown Client';
  }

  get reportTypeName() {
    switch (this.reportType) {
      case ReportTypeEnum.Analysis:
        return 'Analysis';
      case ReportTypeEnum.Auditor:
        return 'Auditor';
    }
  }

  private get batchesDataSource() {
    return new DataSource({
      store: this.batchStore,
      paginate: true,
      pageSize: 100
    });
  }

  private get batchStore() {
    return new CustomStore({
      key: 'BatchId',
      loadMode: 'raw',
      load: this.getClientBatches
    });
  }

  private async getClientBatches() {
    if (this.client == null) {
      return [];
    }

    let batches = await this.batchService.getClientBatchesReportStatus(this.client.ClientId);
    if (batches.length > 0) {
      this.selectedBatch = batches[0];
    }

    return batches;
  }

  private get yesButtonOptions() {
    return {
      text: 'Yes',
      type: 'default',
      stylingMode: 'text',
      onClick: this.yes
    };
  }

  private get noButtonOptions() {
    return {
      text: 'No',
      type: 'default',
      stylingMode: 'text',
      onClick: this.no
    };
  }

  show() {
    this.showDialog = true;
  }

  async yes() {
    let cancel = false;

    if (this.selectedBatch != null && !this.selectedBatch.ReadyForReporting) {
      let message = 'This batch has not been cleared for reporting. Send anyway?';
      let title = 'Batch not cleared for reporting';

      let sendAnyway = await confirm(message, title);
      cancel = !sendAnyway;
    }

    if (!cancel) {
      this.close(true);
    }
  }

  no() {
    this.close(false);
  }

  private close(dialogResult: boolean) {
    this.dialogResult = dialogResult;
    this.showDialog = false;
  }

  private onShowing() {
    this.dialogResult = null;
  }

  @Emit('hiding')
  private onHiding() {
    return this.dialogResult;
  }

  private batchDisplayExpression(batch?: BatchDetailsDto) {
    if (batch == null) {
      return '';
    }

    let status = 'Unknown';
    let reportAvailable = batch.BatchEvents.find(e => e.BatchEventTypeId === BatchEventTypeEnum.ReportAvailable);
    if (reportAvailable != null) {
      if (reportAvailable.ProcessedDate != null) {
        let sentDate = moment(reportAvailable.ProcessedDate).format('M/D/YYYY');
        status = `Sent on ${sentDate}`;
      } else {
        status = 'Not yet sent';
      }
    }

    return `${batch.BatchName}, ${status}`;
  }
}
